import React from 'react';
import ImgIconComp from '../../../components/imgcomp';

const LoaderComp = () => (<div className="loading-comp"><ImgIconComp id="loadinggif" /></div>);

const ModalContent = React.forwardRef((props, ref) => {
  const {
    items,
    rowItem,
    itemsLength,
    showGreenCheckbox,
    dataLoading
  } = props;

  return (
    <>
      <div
        className="addwoboitem-wrapper"
        data-testid="addwoboitem-wrapper"
        ref={ref}
        tabIndex={-1}
        style={{
          overflow: !itemsLength ? 'hidden' : '',
          height: (showGreenCheckbox) ? '290px' : '340px'
        }}
      >
        {rowItem(items)}
        {dataLoading && <LoaderComp />}
      </div>

      {/* { itemsLength ? <div className="gbl-btn" style={btnStyle} onClick={addItem}>{buttonLabel}</div> : ''} */}
    </>
  )
});

export default ModalContent;
